import { createDefaultRecipientRoleFieldBase } from './default-recipient-role-field'
import { FieldEnum, FieldTypeEnum, SelectedFieldEnum } from './fields.dto'

export const Checkboxfield = {
    tag(field){
        return {
            ...createDefaultRecipientRoleFieldBase(field, true),
            field_name: "Checkbox Field",
            field: FieldEnum.CheckboxField,
            type: FieldTypeEnum.Checkbox,
            selected_field: SelectedFieldEnum.CheckboxField,
            field_required: field.field_required ?? "1",
            pre_checked: field.pre_checked ?? "0"
        }
    }
}